import { useTranslation } from 'react-i18next';
import { ClickMenuItem } from './ClickMenu';
import { Icon } from './Icon';
import { useState } from 'react';
import clsx from 'clsx';

interface DeleteFileMenuItemOptionProps {
  onConfirmDelete?: () => void;
}

export function DeleteFileMenuItemOption({ onConfirmDelete }: DeleteFileMenuItemOptionProps) {
  const { t: tFile } = useTranslation('file');
  const [confirmDelete, setConfirmDelete] = useState(false);

  return (
    <>
      <ClickMenuItem
        hideOnClick={confirmDelete}
        className={clsx(confirmDelete && 'bg-darkMode-danger hover:bg-darkMode-danger/70')}
        onClick={() => {
          if (!confirmDelete) return setConfirmDelete(true);
          onConfirmDelete?.();
        }}
      >
        <span className={clsx('text-lg font-medium text-white')}>
          {confirmDelete ? tFile('confirm-delete-file-label') : tFile('delete-file-label')}
        </span>
        <Icon icon="delete" className={clsx(confirmDelete ? 'text-white' : 'text-darkMode-danger')} />
      </ClickMenuItem>
    </>
  );
}
